import type { CoreEmployeeModel } from './typings'

export function techDisplayName(tech: CoreEmployeeModel): string {
  const { username, firstName, lastName } = tech

  return `${username} ${firstName} ${lastName}`.trim()
}

export function isTechValid(tech: CoreEmployeeModel): boolean {
  const { techId, active, enabledForScheduling } = tech

  const idValid = techId !== null

  return idValid && active && enabledForScheduling
}

export function isTechInRegion(
  tech: CoreEmployeeModel,
  techRegionId: string,
): boolean {
  const regions = tech.regions ?? []

  if (techRegionId === '' || regions.length === 0) return true

  return regions.some((r) => r.active && r.id === techRegionId)
}

export function isTechInBranch(
  tech: CoreEmployeeModel,
  branchId: number,
): boolean {
  const branchStr = `${branchId}`
  const branches = tech.branchIds ?? []

  if (branchId === -1) return true
  /**
   * different logic from regions
   * tech w/ no region is in all regions
   * tech w/ no branches is in no branches
   */
  if (branches.length === 0) return false

  return branches.includes(branchStr)
}
